import Vue from "vue";
import Vuex from "vuex";
import Dashboard from "@/store/modules/dashboard";
import Application from "@/store/application";
import Projects from "@/store/modules/projects";
import Modal from "@/store/modules/modal";
import Board from "@/store/modules/board";
import BoardSettings from "@/store/modules/board-settings";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Application,
    Dashboard,
    Projects,
    Modal,
    board: Board,
    boardSettings: BoardSettings,
  },
  state: {},
  mutations: {},
  actions: {},
  plugins: [],
});
export default store;
